const versionList = [
  'RsvpVersion1',
  'RsvpVersion1.1',
  'RsvpVersion1.2',
  'RsvpVersion1.3',
  'RsvpVersion2',
  'RsvpVersion2.ua',
  'RsvpVersion2.1',
  'RsvpVersionC1',
];

export default versionList;
